module.exports = __webpack_public_path__ + "assets/img/QQ.b55d07e9.png";